export default {
    auth: {
        isAuthenticated: false,
        user: {},
        payPeriodType: {},
        agencyType: {},
        adminProfile: {},
        permissions: []
    },
    manageUser: {},
    peerEvaluation: {},
    updateManageUser: {},
    user: {
        userListData: [],
        department: [],
        job: [],
        accessLevel: [],
        permissionList: [],
        functionList: [],
        modulePermissions: []
    },
    location: {},
    newLocation: [],
    agencyRevenue: [],
    locationList: [],
    currentLocation: "",
    plList: {},
    defaultAgencyProfile: {
        profileId: "",
        profile: {}
    },
    piChart: {},
    lineGraph: {},
    revenueProfile: {},
    revenueGoal: {
        "enable": true,
        "combine_new_renewal": true,
        "override_calculate_goal": false,
        "new_revenue_goal": 0,
        "renewal_revenue_goal": 0,
        "total_revenue_goal": 0,
        "ly_compensation_paid": 0,
        "new_revenue_goal_per": 0,
        "renewal_revenue_goal_per": 0,
        "monthly_goal": 0
    },
    overrideRevenueGoal: {},

    // PL Worksheet
    plCategory: [],
    plWorkSheet: {
        "agency_location": 0,
        "profile": "",
        "total_planned_expenses": 0,
        "total_planned_revenue": 0,
        "available_compensation": 0,
        "available_hourly_salary": 0,
        "available_commission": 0,
        "expenses": [],
    },
    operativeItem: [],
    payrollItem: [],
    capitalItem: [],
    marketingItem: [],
    plannedItem: [],

    // Job Description
    jobDescription: [],
    jobTitle: [],

    // KPI
    allKPIData: [],
    allKPICategory: [],
    kpi: {
        destinationCategoryList: [],
        kpiList: []
    },

    // Compensation Profile
    compensation: {},

    // Daily Attendance Sheet
    dailyAttendance: {},

    // Staff Dashboard
    staffDashboard: {
        staffKPIList: [],
        requests: [],
        trainingVideoList: []
    },

    // Staff Data
    staffData: {
        correctionDataList: [],
        staffKPIList: [],
        userListData: [],
        requests: [],
        messages: []
    },

    // Organic Growth Wizard
    organicGrowthWizard: {
        lobList: []
    },

    // Report
    report: {
        compensationSetting: {},
        compensationBatch: []
    },

    //Compliance Audit
    complianceAudit: {
        categoryMasterList: [],
        itemList: [],
        userList : [],
        categoryList : [],
        itemsAllotedToUser : {}     
    },

    //Save State
    state: {},

    // Installation wizard
    iwData: {
        modules: [],
        videos: [],
    },

    // KPI Planning
    kpiPlanning: {
        categories: [],
        destinationItems: [],
        habitItems: [],
        jobKPIs: [],
        allJobKPIs: [],
        jobTitleList: []
    },

    //AgencyMonitor
    agencyMonitor: {
        headerSettings: {},
        userData: [],
        pageData: [],
        pagePositionData: [],
        kpis: [],
        pageSettingsData: {},
        individualPageData: {},
        agencyProfiles: []
    },

    // Knowledgebase
    knowledgeBase: {
        categories: [],
        itemList: [],
        faqList: [],
        iwItemList: []
    },

    // PTO
    pto: {
        settings: {},
        typeList: [],
        reasonList: [],
        holidayList: [],
        assignedHolidayList: [],
        timeoffRequestList: [],
        pendingRequestList: [],
        ptoInfoList: [],
        staffPTOInfo: {},
        leaveList: [],
        userRequestList: [],
        staffAllowedList: [],
        blackoutDayList: [],
        birthDayList: []
    },

    // Producer Compensation
    producer: {
        userList: [],
        periods: [],
        numbers: [],
        lobList: [],
        categoryList: [],
        packageMasterList: [],
        packageMasterFullList: [],
        packageList: [],
        conditionList: [],
        assignedPackageList: [],
        settings: {},
    }
};



// WEBPACK FOOTER //
// ./src/reducers/InitialState.js